/**
 * Whether a keystroke landed somewhere the user is entering text.
 *
 * ⌘Z means two different things depending on where the caret is: in a note it
 * is the editor's own undo, and taking it for "undo delete" would make typing
 * unrecoverable. Everywhere else it walks back the last deletion.
 */
export function inTextEntry(target: EventTarget | null): boolean {
  const el = target as Element | null
  if (!el || typeof el.closest !== 'function') return false
  return el.closest('.ProseMirror, input, textarea, [contenteditable="true"]') !== null
}

/** The platform's undo chord: ⌘Z on a Mac, Ctrl+Z elsewhere. */
export function isUndoChord(e: Pick<KeyboardEvent, 'key' | 'metaKey' | 'ctrlKey' | 'shiftKey'>): boolean {
  return (e.metaKey || e.ctrlKey) && !e.shiftKey && e.key.toLowerCase() === 'z'
}
